import { Link } from "gatsby"
import React, { useState, useEffect } from "react"
import { Container, Row, Col, Form } from "react-bootstrap"
import ScrollAnimation from 'react-animate-on-scroll'; 
import parse from "html-react-parser"; 
import { NETWORK_PAGE_URL, CONTACT_PAGE_URL } from "../common/site/constants"

import "../Home/VideoBlock/VideoBlock.scss"
// markup
const VideoBlock = (props ) => {
  const [isPlay, setPlay] = useState(false);

  return ( 
        <React.Fragment>
           <div className="video-block-wrap components--AreaGuideDetails--VideoBlock--VideoBlock">
           <Container>
                    <Row>
                      <Col xl="8" lg="7">
                      <ScrollAnimation animateIn="fadeInUp" animateOnce>
                        <div className="block-content">
                          <div className="block-text">
                          {parse(props.Add_Static_Content)}
                          
                          </div>
                        </div>
                      </ScrollAnimation>
                      </Col>
                      <Col xl="4" lg="5" className="block-content block-text">
                        <div className="guide-details-right-block main-banner">
                          <div className="first">
                          <form>
                            <div className="btn-wrap row">
                              <Col lg={6} className="cta col-1">
                                <Link to={NETWORK_PAGE_URL.alias} className="btn btn-secondary">
                                  <span>Our Brands</span>Our Network
                                </Link>
                              </Col>
                              <Col lg={6} className="cta col-2">
                                <Link to={CONTACT_PAGE_URL.alias} className="btn">
                                  <span>Get in touch</span>Contact Us
                                </Link>
                              </Col>
                            </div>
                          </form>
                          
                          </div>

                          <div className="info-text">
                            <p><b>Not local to Ashford?</b> We’ve got 40+ branches across Kent and surrounding areas – find your local one.</p>
                          </div>


                        </div>
                      </Col>
                    </Row>
             </Container>
           </div>
        </React.Fragment>
    )
}
export default VideoBlock